import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { getPaddingClasses } from '../../utils/padding.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "container--p-none": "web_ui__Container__container--p-none",
  "container--pt-none": "web_ui__Container__container--pt-none",
  "container--pr-none": "web_ui__Container__container--pr-none",
  "container--pb-none": "web_ui__Container__container--pb-none",
  "container--pl-none": "web_ui__Container__container--pl-none",
  "container--px-none": "web_ui__Container__container--px-none",
  "container--py-none": "web_ui__Container__container--py-none",
  "container--p-x-small": "web_ui__Container__container--p-x-small",
  "container--pt-x-small": "web_ui__Container__container--pt-x-small",
  "container--pr-x-small": "web_ui__Container__container--pr-x-small",
  "container--pb-x-small": "web_ui__Container__container--pb-x-small",
  "container--pl-x-small": "web_ui__Container__container--pl-x-small",
  "container--px-x-small": "web_ui__Container__container--px-x-small",
  "container--py-x-small": "web_ui__Container__container--py-x-small",
  "container--p-small": "web_ui__Container__container--p-small",
  "container--pt-small": "web_ui__Container__container--pt-small",
  "container--pr-small": "web_ui__Container__container--pr-small",
  "container--pb-small": "web_ui__Container__container--pb-small",
  "container--pl-small": "web_ui__Container__container--pl-small",
  "container--px-small": "web_ui__Container__container--px-small",
  "container--py-small": "web_ui__Container__container--py-small",
  "container--p-regular": "web_ui__Container__container--p-regular",
  "container--pt-regular": "web_ui__Container__container--pt-regular",
  "container--pr-regular": "web_ui__Container__container--pr-regular",
  "container--pb-regular": "web_ui__Container__container--pb-regular",
  "container--pl-regular": "web_ui__Container__container--pl-regular",
  "container--px-regular": "web_ui__Container__container--px-regular",
  "container--py-regular": "web_ui__Container__container--py-regular",
  "container--p-medium": "web_ui__Container__container--p-medium",
  "container--pt-medium": "web_ui__Container__container--pt-medium",
  "container--pr-medium": "web_ui__Container__container--pr-medium",
  "container--pb-medium": "web_ui__Container__container--pb-medium",
  "container--pl-medium": "web_ui__Container__container--pl-medium",
  "container--px-medium": "web_ui__Container__container--px-medium",
  "container--py-medium": "web_ui__Container__container--py-medium",
  "container--p-large": "web_ui__Container__container--p-large",
  "container--pt-large": "web_ui__Container__container--pt-large",
  "container--pr-large": "web_ui__Container__container--pr-large",
  "container--pb-large": "web_ui__Container__container--pb-large",
  "container--pl-large": "web_ui__Container__container--pl-large",
  "container--px-large": "web_ui__Container__container--px-large",
  "container--py-large": "web_ui__Container__container--py-large",
  "container--p-larger": "web_ui__Container__container--p-larger",
  "container--pt-larger": "web_ui__Container__container--pt-larger",
  "container--pr-larger": "web_ui__Container__container--pr-larger",
  "container--pb-larger": "web_ui__Container__container--pb-larger",
  "container--pl-larger": "web_ui__Container__container--pl-larger",
  "container--px-larger": "web_ui__Container__container--px-larger",
  "container--py-larger": "web_ui__Container__container--py-larger",
  "container--p-x-large": "web_ui__Container__container--p-x-large",
  "container--pt-x-large": "web_ui__Container__container--pt-x-large",
  "container--pr-x-large": "web_ui__Container__container--pr-x-large",
  "container--pb-x-large": "web_ui__Container__container--pb-x-large",
  "container--pl-x-large": "web_ui__Container__container--pl-x-large",
  "container--px-x-large": "web_ui__Container__container--px-x-large",
  "container--py-x-large": "web_ui__Container__container--py-x-large",
  "container--p-x-larger": "web_ui__Container__container--p-x-larger",
  "container--pt-x-larger": "web_ui__Container__container--pt-x-larger",
  "container--pr-x-larger": "web_ui__Container__container--pr-x-larger",
  "container--pb-x-larger": "web_ui__Container__container--pb-x-larger",
  "container--pl-x-larger": "web_ui__Container__container--pl-x-larger",
  "container--px-x-larger": "web_ui__Container__container--px-x-larger",
  "container--py-x-larger": "web_ui__Container__container--py-x-larger",
  "container--p-x2-large": "web_ui__Container__container--p-x2-large",
  "container--pt-x2-large": "web_ui__Container__container--pt-x2-large",
  "container--pr-x2-large": "web_ui__Container__container--pr-x2-large",
  "container--pb-x2-large": "web_ui__Container__container--pb-x2-large",
  "container--pl-x2-large": "web_ui__Container__container--pl-x2-large",
  "container--px-x2-large": "web_ui__Container__container--px-x2-large",
  "container--py-x2-large": "web_ui__Container__container--py-x2-large",
  "container--p-x3-large": "web_ui__Container__container--p-x3-large",
  "container--pt-x3-large": "web_ui__Container__container--pt-x3-large",
  "container--pr-x3-large": "web_ui__Container__container--pr-x3-large",
  "container--pb-x3-large": "web_ui__Container__container--pb-x3-large",
  "container--pl-x3-large": "web_ui__Container__container--pl-x3-large",
  "container--px-x3-large": "web_ui__Container__container--px-x3-large",
  "container--py-x3-large": "web_ui__Container__container--py-x3-large",
  "container--p-x4-large": "web_ui__Container__container--p-x4-large",
  "container--pt-x4-large": "web_ui__Container__container--pt-x4-large",
  "container--pr-x4-large": "web_ui__Container__container--pr-x4-large",
  "container--pb-x4-large": "web_ui__Container__container--pb-x4-large",
  "container--pl-x4-large": "web_ui__Container__container--pl-x4-large",
  "container--px-x4-large": "web_ui__Container__container--px-x4-large",
  "container--py-x4-large": "web_ui__Container__container--py-x4-large",
  "container--p-x5-large": "web_ui__Container__container--p-x5-large",
  "container--pt-x5-large": "web_ui__Container__container--pt-x5-large",
  "container--pr-x5-large": "web_ui__Container__container--pr-x5-large",
  "container--pb-x5-large": "web_ui__Container__container--pb-x5-large",
  "container--pl-x5-large": "web_ui__Container__container--pl-x5-large",
  "container--px-x5-large": "web_ui__Container__container--px-x5-large",
  "container--py-x5-large": "web_ui__Container__container--py-x5-large",
  "container--p-x6-large": "web_ui__Container__container--p-x6-large",
  "container--pt-x6-large": "web_ui__Container__container--pt-x6-large",
  "container--pr-x6-large": "web_ui__Container__container--pr-x6-large",
  "container--pb-x6-large": "web_ui__Container__container--pb-x6-large",
  "container--pl-x6-large": "web_ui__Container__container--pl-x6-large",
  "container--px-x6-large": "web_ui__Container__container--px-x6-large",
  "container--py-x6-large": "web_ui__Container__container--py-x6-large",
  "container--p-space-0": "web_ui__Container__container--p-space-0",
  "container--pt-space-0": "web_ui__Container__container--pt-space-0",
  "container--pr-space-0": "web_ui__Container__container--pr-space-0",
  "container--pb-space-0": "web_ui__Container__container--pb-space-0",
  "container--pl-space-0": "web_ui__Container__container--pl-space-0",
  "container--px-space-0": "web_ui__Container__container--px-space-0",
  "container--py-space-0": "web_ui__Container__container--py-space-0",
  "container--p-space-50": "web_ui__Container__container--p-space-50",
  "container--pt-space-50": "web_ui__Container__container--pt-space-50",
  "container--pr-space-50": "web_ui__Container__container--pr-space-50",
  "container--pb-space-50": "web_ui__Container__container--pb-space-50",
  "container--pl-space-50": "web_ui__Container__container--pl-space-50",
  "container--px-space-50": "web_ui__Container__container--px-space-50",
  "container--py-space-50": "web_ui__Container__container--py-space-50",
  "container--p-space-100": "web_ui__Container__container--p-space-100",
  "container--pt-space-100": "web_ui__Container__container--pt-space-100",
  "container--pr-space-100": "web_ui__Container__container--pr-space-100",
  "container--pb-space-100": "web_ui__Container__container--pb-space-100",
  "container--pl-space-100": "web_ui__Container__container--pl-space-100",
  "container--px-space-100": "web_ui__Container__container--px-space-100",
  "container--py-space-100": "web_ui__Container__container--py-space-100",
  "container--p-space-150": "web_ui__Container__container--p-space-150",
  "container--pt-space-150": "web_ui__Container__container--pt-space-150",
  "container--pr-space-150": "web_ui__Container__container--pr-space-150",
  "container--pb-space-150": "web_ui__Container__container--pb-space-150",
  "container--pl-space-150": "web_ui__Container__container--pl-space-150",
  "container--px-space-150": "web_ui__Container__container--px-space-150",
  "container--py-space-150": "web_ui__Container__container--py-space-150",
  "container--p-space-200": "web_ui__Container__container--p-space-200",
  "container--pt-space-200": "web_ui__Container__container--pt-space-200",
  "container--pr-space-200": "web_ui__Container__container--pr-space-200",
  "container--pb-space-200": "web_ui__Container__container--pb-space-200",
  "container--pl-space-200": "web_ui__Container__container--pl-space-200",
  "container--px-space-200": "web_ui__Container__container--px-space-200",
  "container--py-space-200": "web_ui__Container__container--py-space-200",
  "container--p-space-300": "web_ui__Container__container--p-space-300",
  "container--pt-space-300": "web_ui__Container__container--pt-space-300",
  "container--pr-space-300": "web_ui__Container__container--pr-space-300",
  "container--pb-space-300": "web_ui__Container__container--pb-space-300",
  "container--pl-space-300": "web_ui__Container__container--pl-space-300",
  "container--px-space-300": "web_ui__Container__container--px-space-300",
  "container--py-space-300": "web_ui__Container__container--py-space-300",
  "container--p-space-400": "web_ui__Container__container--p-space-400",
  "container--pt-space-400": "web_ui__Container__container--pt-space-400",
  "container--pr-space-400": "web_ui__Container__container--pr-space-400",
  "container--pb-space-400": "web_ui__Container__container--pb-space-400",
  "container--pl-space-400": "web_ui__Container__container--pl-space-400",
  "container--px-space-400": "web_ui__Container__container--px-space-400",
  "container--py-space-400": "web_ui__Container__container--py-space-400",
  "container--p-space-500": "web_ui__Container__container--p-space-500",
  "container--pt-space-500": "web_ui__Container__container--pt-space-500",
  "container--pr-space-500": "web_ui__Container__container--pr-space-500",
  "container--pb-space-500": "web_ui__Container__container--pb-space-500",
  "container--pl-space-500": "web_ui__Container__container--pl-space-500",
  "container--px-space-500": "web_ui__Container__container--px-space-500",
  "container--py-space-500": "web_ui__Container__container--py-space-500",
  "container--p-space-600": "web_ui__Container__container--p-space-600",
  "container--pt-space-600": "web_ui__Container__container--pt-space-600",
  "container--pr-space-600": "web_ui__Container__container--pr-space-600",
  "container--pb-space-600": "web_ui__Container__container--pb-space-600",
  "container--pl-space-600": "web_ui__Container__container--pl-space-600",
  "container--px-space-600": "web_ui__Container__container--px-space-600",
  "container--py-space-600": "web_ui__Container__container--py-space-600",
  "container--p-space-700": "web_ui__Container__container--p-space-700",
  "container--pt-space-700": "web_ui__Container__container--pt-space-700",
  "container--pr-space-700": "web_ui__Container__container--pr-space-700",
  "container--pb-space-700": "web_ui__Container__container--pb-space-700",
  "container--pl-space-700": "web_ui__Container__container--pl-space-700",
  "container--px-space-700": "web_ui__Container__container--px-space-700",
  "container--py-space-700": "web_ui__Container__container--py-space-700",
  "container--p-space-900": "web_ui__Container__container--p-space-900",
  "container--pt-space-900": "web_ui__Container__container--pt-space-900",
  "container--pr-space-900": "web_ui__Container__container--pr-space-900",
  "container--pb-space-900": "web_ui__Container__container--pb-space-900",
  "container--pl-space-900": "web_ui__Container__container--pl-space-900",
  "container--px-space-900": "web_ui__Container__container--px-space-900",
  "container--py-space-900": "web_ui__Container__container--py-space-900",
  "container--p-space-800": "web_ui__Container__container--p-space-800",
  "container--pt-space-800": "web_ui__Container__container--pt-space-800",
  "container--pr-space-800": "web_ui__Container__container--pr-space-800",
  "container--pb-space-800": "web_ui__Container__container--pb-space-800",
  "container--pl-space-800": "web_ui__Container__container--pl-space-800",
  "container--px-space-800": "web_ui__Container__container--px-space-800",
  "container--py-space-800": "web_ui__Container__container--py-space-800",
  "container--p-space-1000": "web_ui__Container__container--p-space-1000",
  "container--pt-space-1000": "web_ui__Container__container--pt-space-1000",
  "container--pr-space-1000": "web_ui__Container__container--pr-space-1000",
  "container--pb-space-1000": "web_ui__Container__container--pb-space-1000",
  "container--pl-space-1000": "web_ui__Container__container--pl-space-1000",
  "container--px-space-1000": "web_ui__Container__container--px-space-1000",
  "container--py-space-1000": "web_ui__Container__container--py-space-1000",
  "container--p-space-1100": "web_ui__Container__container--p-space-1100",
  "container--pt-space-1100": "web_ui__Container__container--pt-space-1100",
  "container--pr-space-1100": "web_ui__Container__container--pr-space-1100",
  "container--pb-space-1100": "web_ui__Container__container--pb-space-1100",
  "container--pl-space-1100": "web_ui__Container__container--pl-space-1100",
  "container--px-space-1100": "web_ui__Container__container--px-space-1100",
  "container--py-space-1100": "web_ui__Container__container--py-space-1100",
  "container--p-space-1200": "web_ui__Container__container--p-space-1200",
  "container--pt-space-1200": "web_ui__Container__container--pt-space-1200",
  "container--pr-space-1200": "web_ui__Container__container--pr-space-1200",
  "container--pb-space-1200": "web_ui__Container__container--pb-space-1200",
  "container--pl-space-1200": "web_ui__Container__container--pl-space-1200",
  "container--px-space-1200": "web_ui__Container__container--px-space-1200",
  "container--py-space-1200": "web_ui__Container__container--py-space-1200",
  "container--p-space-1400": "web_ui__Container__container--p-space-1400",
  "container--pt-space-1400": "web_ui__Container__container--pt-space-1400",
  "container--pr-space-1400": "web_ui__Container__container--pr-space-1400",
  "container--pb-space-1400": "web_ui__Container__container--pb-space-1400",
  "container--pl-space-1400": "web_ui__Container__container--pl-space-1400",
  "container--px-space-1400": "web_ui__Container__container--px-space-1400",
  "container--py-space-1400": "web_ui__Container__container--py-space-1400",
  "container--p-space-1600": "web_ui__Container__container--p-space-1600",
  "container--pt-space-1600": "web_ui__Container__container--pt-space-1600",
  "container--pr-space-1600": "web_ui__Container__container--pr-space-1600",
  "container--pb-space-1600": "web_ui__Container__container--pb-space-1600",
  "container--pl-space-1600": "web_ui__Container__container--pl-space-1600",
  "container--px-space-1600": "web_ui__Container__container--px-space-1600",
  "container--py-space-1600": "web_ui__Container__container--py-space-1600",
  "container--p-space-2400": "web_ui__Container__container--p-space-2400",
  "container--pt-space-2400": "web_ui__Container__container--pt-space-2400",
  "container--pr-space-2400": "web_ui__Container__container--pr-space-2400",
  "container--pb-space-2400": "web_ui__Container__container--pb-space-2400",
  "container--pl-space-2400": "web_ui__Container__container--pl-space-2400",
  "container--px-space-2400": "web_ui__Container__container--px-space-2400",
  "container--py-space-2400": "web_ui__Container__container--py-space-2400",
  "container--p-space-3200": "web_ui__Container__container--p-space-3200",
  "container--pt-space-3200": "web_ui__Container__container--pt-space-3200",
  "container--pr-space-3200": "web_ui__Container__container--pr-space-3200",
  "container--pb-space-3200": "web_ui__Container__container--pb-space-3200",
  "container--pl-space-3200": "web_ui__Container__container--pl-space-3200",
  "container--px-space-3200": "web_ui__Container__container--px-space-3200",
  "container--py-space-3200": "web_ui__Container__container--py-space-3200",
  "width-content": "web_ui__Container__width-content",
  "width-wide": "web_ui__Container__width-wide",
  "container": "web_ui__Container__container",
  "styling-narrow": "web_ui__Container__styling-narrow",
  "styling-tight": "web_ui__Container__styling-tight",
  "styling-wide": "web_ui__Container__styling-wide"
};

var CONTAINER_STYLING_VALUES = ['narrow', 'tight', 'wide'];
var CONTAINER_WIDTH_VALUES = ['content', 'wide'];
/* ---------- Back-compat shims (public API) ---------- */
var CONTAINER_STYLING = {
  Narrow: 'narrow',
  Tight: 'tight',
  Wide: 'wide'
};
var CONTAINER_WIDTH = {
  Content: 'content',
  Wide: 'wide'
};
var cssClasses = classNames.bind(styles);
var ContainerBase = function ContainerBase(_ref) {
  var styling = _ref.styling,
    width = _ref.width,
    children = _ref.children,
    testId = _ref.testId,
    padding = _ref.padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingX = _ref.paddingHorizontal,
    paddingY = _ref.paddingVertical;
  var paddingClass = getPaddingClasses(styles, 'container', {
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingX: paddingX,
    paddingY: paddingY
  });
  var hasPaddingProps = !!(padding || paddingTop || paddingRight || paddingBottom || paddingLeft || paddingX || paddingY);
  var shouldIncludeContainerClass = !hasPaddingProps;
  var shouldApplyStyling = !hasPaddingProps && !!styling;
  var containerClass = cssClasses(shouldIncludeContainerClass && 'container', paddingClass, _defineProperty(_defineProperty({}, "styling-".concat(styling || ''), shouldApplyStyling), "width-".concat(width || ''), !!width));
  return /*#__PURE__*/jsx("div", {
    className: containerClass,
    "data-testid": testId,
    children: children
  });
};
ContainerBase.displayName = 'Container';

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Container = _Object$assign(ContainerBase, {
  /** @deprecated Use string unions, e.g. styling="narrow" */
  Styling: CONTAINER_STYLING,
  /** @deprecated Use string unions, e.g. width="content" */
  Width: CONTAINER_WIDTH
});

export { CONTAINER_STYLING, CONTAINER_STYLING_VALUES, CONTAINER_WIDTH, CONTAINER_WIDTH_VALUES, Container, Container as default };
//# sourceMappingURL=Container.js.map
